import { Link, useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { categories } from "@/mocks/news";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Navbar />
      <main className="mx-auto flex w-full max-w-site flex-1 flex-col items-center justify-center px-4 py-20 text-center md:px-6">
        <p className="font-heading text-[80px] font-black leading-none text-background-300 md:text-[140px]">
          404
        </p>
        <h1 className="-mt-4 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
          这条线索走到了尽头
        </h1>
        <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
          你访问的页面不存在或已经调整。换个方向，从下面的栏目继续追瓜吧。
        </p>
        <p className="mt-3 font-label text-xs text-foreground-400">{location.pathname}</p>

        <div className="mt-8 flex flex-wrap justify-center gap-2">
          <Link
            to="/"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-4-line" aria-hidden="true"></i>
            返回首页
          </Link>
          {categories.slice(0, 3).map((item) => (
            <Link
              key={item.slug}
              to={`/category/${item.slug}`}
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 px-5 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
            >
              {item.name}
            </Link>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}